/*$('#myCarousel').carousel({
    interval: 1000
})*/

$('.carousel .carousel-item').each(function() {
    var minPerSlide = 4;
    var next = $(this).next();
    if (!next.length) {
        next = $(this).siblings(':first');
    }
    next.children(':first-child').clone().appendTo($(this));

    for (var i = 0; i < minPerSlide; i++) {
        next = next.next();
        if (!next.length) {
            next = $(this).siblings(':first');
        }

        next.children(':first-child').clone().appendTo($(this));
    }
});

/*lightbox*/

$('.carousel_column').on('click', 'img', function(){
    var source = $(this).first('img').attr('src');
    $('.modal_image').attr('src', source);
    console.log(source);
});